import Type1 from "./footerType1";

export default Type1;
